import React from 'react';

import {useSnackbar} from 'notistack';
import {useHistory} from 'react-router-dom';

import {
    EfeCatalog,
    EfeCatalogValue,
    EfeResponse,
    Layout,
    RegisterServiceValues,
    RegisterValues,
} from 'commons/models';
import {
    CATALOGS,
    COMPLEMENT_MODULES,
    Constants,
    HistoryRoutes,
    Messages,
    MODULES,
    SnackbarVariants,
} from 'commons/constants';
import {Utils} from 'commons';
import {useSpinner} from 'hooks';
import RegisterForm from './register-form/RegisterForm';
import {useMenuContext} from 'context/onboarding-menu/OnboardingMenu';
import {CatalogServices, DocumentServices, LayoutServices} from 'services';
import {useCatalogContext} from 'context/onboarding-catalog/OnboardingCatalog';
import {getCatalogMessage} from 'commons/utils/Messagefunctions';
import {modulesValidation} from 'commons/utils/Functions';
import {useUserContext} from 'context/user/UserContext';
import {useAnalytics} from 'hooks/AnalyticsHook';

function ExpedientManual() {
    const history = useHistory();
    const {user} = useUserContext();
    const {sendPageView} = useAnalytics();
    const {catalogs, updateCatalogs} = useCatalogContext();
    const {enqueueSnackbar} = useSnackbar();
    const {setPersonType, updateLayout, updateMenu, personType, foreign, setForeign} =
        useMenuContext();
    const [isLoading, setIsLoading] = React.useState(false);
    const [options, setOptions] = React.useState<EfeCatalogValue[]>([]);

    React.useEffect(() => {
        sendPageView(HistoryRoutes.REGISTER);
        (async () => {
            const data: EfeCatalog | undefined = catalogs.find(
                (catalog: EfeCatalog) => catalog.name === CATALOGS.PersonTypes
            );
            if (data) {
                setOptions(data.values);
            } else {
                setIsLoading(true);
                try {
                    const response = await CatalogServices.getValuesFrom(CATALOGS.PersonTypes);
                    if (response.data && response.data.values && response.data.values.length) {
                        setOptions(response.data.values);
                        updateCatalogs(response.data);
                    } else {
                        enqueueSnackbar(getCatalogMessage('Tipo de persona'), {
                            variant: SnackbarVariants.ERROR,
                        });
                    }
                } catch (error) {
                    enqueueSnackbar(getCatalogMessage('Tipo de persona'), {
                        variant: SnackbarVariants.ERROR,
                    });
                }
                setIsLoading(false);
            }
        })();
    }, []);

    async function registration(params: RegisterServiceValues) {
        try {
            const response: EfeResponse<Layout> = await LayoutServices.getLayoutByPersonType(
                params
            );
            if (response.data && response.data.views && response.data.views.length) {
                if (params.personType) {
                    setPersonType(params.personType);
                }
                setForeign(params.foreign);
                updateLayout(response.data);
                updateMenu([
                    ...modulesValidation([...MODULES], response.data),
                    ...COMPLEMENT_MODULES,
                ]);
                setIsLoading(false);
                history.push(HistoryRoutes.REGULATORY_FRAMEWORK);
            } else {
                enqueueSnackbar(Messages.LAYOUT_ERROR, {
                    variant: SnackbarVariants.ERROR,
                });
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            enqueueSnackbar(Messages.LAYOUT_ERROR, {
                variant: SnackbarVariants.ERROR,
            });
        }
    }

    async function submitHandler(values: RegisterValues) {
        try {
            setIsLoading(true);
            if (values.download) {
                const response = await DocumentServices.getDocument(Constants.DOC_MANUAL);
                Utils.functions.downloadDocs(response, `${Constants.DOC_MANUAL}.pdf`);
                enqueueSnackbar(Messages.FILE_DOWNLOAD_OK, {
                    variant: SnackbarVariants.SUCCESS,
                });
                setIsLoading(false);
            } else {
                registration({
                    foreign: values.foreign,
                    personType: values.personType,
                    rol: values.rol,
                    isMigrated: user.isMigrated,
                });
            }
        } catch (error) {
            setIsLoading(false);
            enqueueSnackbar(Messages.FILE_DOWNLOAD_ERROR, {
                variant: SnackbarVariants.ERROR,
            });
        }
    }

    /* eslint-disable react/jsx-handler-names */
    return (
        <div className='ExpedientManual'>
            {isLoading && useSpinner(isLoading)}
            <RegisterForm
                personType={personType}
                options={options}
                isLoading={isLoading}
                submitHandler={submitHandler}
                foreign={foreign}
            />
        </div>
    );
}

export default ExpedientManual;
